module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "main-view"
  }, [_c('CellTips', [_vm._v("UI组件")]), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-window-minimize",
      "title": "BUTTONS",
      "link": "button"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-wpforms",
      "title": "FORMS",
      "link": "form"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-list",
      "title": "LIST",
      "link": "list"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-address-card-o",
      "title": "PANELS",
      "link": "panel"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-braille",
      "title": "PREVIEW",
      "link": "preview"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-credit-card",
      "title": "CARDS",
      "link": "card"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-magic",
      "title": "PROGRESS",
      "link": "progress"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-circle-o",
      "title": "ICONS",
      "link": "icon"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-cut",
      "title": "CUT_OFF",
      "link": "cut-off"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-globe",
      "title": "HEADERS",
      "link": "header"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-link",
      "title": "FOOTER",
      "link": "footer"
    }
  }), _vm._v(" "), _c('CellTips', [_vm._v("交互组件")]), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-hand-stop-o",
      "title": "Scroller",
      "link": "scroller"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-indent",
      "title": "CATEGORY ",
      "link": "category"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-th-list",
      "title": "ACTION_SHEET",
      "link": "action-sheet"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-comment-o",
      "title": "DIALOG",
      "link": "dialog"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-commenting",
      "title": "TOAST",
      "link": "toast"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-info-circle",
      "title": "INFO",
      "link": "info"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-calendar",
      "title": "MULTI_PICKER",
      "link": "multi-picker"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-search",
      "title": "SEARCH",
      "link": "search"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-lock",
      "title": "PASSWORD",
      "link": "password"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-hand-o-up",
      "title": "TABS",
      "link": "tabs"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-window-restore",
      "title": "NAV",
      "link": "navs"
    }
  }), _vm._v(" "), _c('ListItem', {
    attrs: {
      "icon": "fa fa-map",
      "title": "STEP",
      "link": "step"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-8795c1d6!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/main.vue
// module id = 273
// module chunks = 0